import { AccountDocumentDocTypeEnum } from '@b-stock/account-api-client'
import { findBestVariant } from '@b-stock/fe-core/bstock-next/helpers'
import { type SellerInfo } from '@b-stock/fe-core/bstock-next/queries'
import type { DocumentDto } from '@b-stock/listing-api-client'

import type { Range } from '@/components/listings/search/SearchFilters/shared/commonTypes'

export const getSellerLogo = (
  documents?:
    | (DocumentDto | null)[]
    | SellerInfo['account']['documents']
    | null,
  bestVariantSize: number = 62
): string | null => {
  const filtered = documents?.filter(
    (doc): doc is NonNullable<typeof doc> => doc !== null
  )

  if (!filtered?.length) return null

  const svg = filtered.find(
    ({ docType }) => (docType as string) === 'LOGO_VECTOR'
  )?.url
  const logo = filtered.find(
    ({ docType }) => (docType as string) === AccountDocumentDocTypeEnum.Logo
  )
  const bestLogoVariant = findBestVariant(bestVariantSize, logo?.variants)?.url

  return svg || bestLogoVariant || logo?.url || null
}

export const sanitizeRange = (value: Range): Range => {
  let [min, max] = value
  min = min ? Math.abs(min) : null
  max = max ? Math.abs(max) : null
  return [min, max]
}

export const getDateTimePart = (
  parts: Intl.DateTimeFormatPart[],
  type: Intl.DateTimeFormatPart['type']
): string | undefined => parts.find((part) => part.type === type)?.value
